var _defs, _g, _g2, _g3, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _circle, _path0, _path1, _path10;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIllust404(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 649.973,
    height: 503.279,
    viewBox: "0 0 649.973 503.279",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.766,
    y1: -6.098,
    x2: 0.766,
    y2: -5.098,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "gray",
    stopOpacity: 0.251
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "gray",
    stopOpacity: 0.122
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "gray",
    stopOpacity: 0.102
  })))), /*#__PURE__*/React.createElement("g", {
    id: "\\u30B0\\u30EB\\u30FC\\u30D7_796",
    "data-name": "\\u30B0\\u30EB\\u30FC\\u30D7 796",
    transform: "translate(-406.247 -3473.096)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_500",
    "data-name": "\\u30D1\\u30B9 500",
    d: "M439.064,3496.544c-17.8,11.484-31.023,32.136-32.638,54.744-2.339,32.9,18.649,62.059,41.018,84.033s48.153,41.8,61.191,71.508c14.307,32.662,9.42,74.367-11.962,101.988-9.2,11.89-22.01,23.924-20.27,39.427,1.627,14.462,16.358,23.487,29.6,22.812s25.234-8.326,36.795-15.455c41.448-25.569,86.617-47.471,134.141-47.884,50.952-.437,99.075,23.714,145.254,47.375l66.389,34.026c13.8,7.076,27.961,14.259,43.129,15.784s30.569-2.811,44.038-10.652c14.414-8.373,27.513-22.094,30.461-39.726,3.906-23.434-10.766-45.707-12.751-69.433-1.95-23.475,8.7-45.982,21.1-65.192s27.052-37.19,35.084-59.05c16.5-44.929.431-98.913-31.3-132.539s-76.21-49.349-120.092-53.906c-16.454-1.711-33.111-2-49.457.7-32.549,5.383-62.406,22.3-93.3,34.69-55.228,22.129-116.952,29.809-172.922,10.018C537.511,3503.9,485.668,3466.484,439.064,3496.544Z",
    transform: "translate(0)",
    fill: "#224ea8",
    opacity: 0.1,
    style: {
      isolation: "isolate"
    }
  }), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u30B0\\u30EB\\u30FC\\u30D7_792",
    "data-name": "\\u30B0\\u30EB\\u30FC\\u30D7 792",
    transform: "translate(531.022 3496.102)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_501",
    "data-name": "\\u30D1\\u30B9 501",
    d: "M1014.983,3751.859v-240.3H614.866v313.092h400.117v-30.246s.122-33.6.122-33.637C1015.368,3752.158,1015.368,3760.531,1014.983,3751.859Z",
    transform: "translate(-614.866 -3511.561)",
    fill: "#a1a3b2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\u9577\\u65B9\\u5F62_502",
    "data-name": "\\u9577\\u65B9\\u5F62 502",
    width: 384.693,
    height: 295.149,
    transform: "translate(7.865 8.972)",
    fill: "#f4f5f6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\u9577\\u65B9\\u5F62_503",
    "data-name": "\\u9577\\u65B9\\u5F62 503",
    width: 34.092,
    height: 9.57,
    transform: "translate(366.332 320.581)",
    fill: "#a1a3b2"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "\\u30B0\\u30EB\\u30FC\\u30D7_793",
    "data-name": "\\u30B0\\u30EB\\u30FC\\u30D7 793",
    transform: "translate(565.526 3529.996)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_502",
    "data-name": "\\u30D1\\u30B9 502",
    d: "M776.394,3657.521l-22.31-.366-.474,28.853-16.272-.267.474-28.853-65.255-1.071.193-11.742,61.316-75.844,18.117.3-58.755,73.2,45.125.741.419-25.5,15.769.258-.419,25.5,22.31.366Z",
    transform: "translate(-672.557 -3568.23)",
    fill: "#224ea8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_503",
    "data-name": "\\u30D1\\u30B9 503",
    d: "M886.17,3681.351q-10.7-7.307-16.686-21t-5.678-32.31q.305-18.621,6.736-32.106t17.366-20.437a46.22,46.22,0,0,1,49.319.81q10.7,7.309,16.686,21t5.678,32.31q-.305,18.62-6.735,32.106t-17.367,20.437a46.214,46.214,0,0,1-49.318-.809Zm47.624-18.6q8.658-11.436,9.022-33.411t-7.921-33.688q-8.283-11.716-22.372-11.946a26.755,26.755,0,0,0-22.92,11.2q-8.663,11.435-9.022,33.41t7.92,33.69a26.762,26.762,0,0,0,22.541,11.948Q925.131,3674.188,933.793,3662.752Z",
    transform: "translate(-749.414 -3568.448)",
    fill: "#224ea8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_504",
    "data-name": "\\u30D1\\u30B9 504",
    d: "M1151.1,3663.674l-22.311-.366-.474,28.853-16.272-.268.474-28.853-65.255-1.071.193-11.742,61.316-75.843,18.117.3-58.755,73.2,45.125.741.419-25.5,15.768.259-.419,25.5,22.311.367Z",
    transform: "translate(-823.152 -3570.703)",
    fill: "#224ea8"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "\\u30B0\\u30EB\\u30FC\\u30D7_794",
    "data-name": "\\u30B0\\u30EB\\u30FC\\u30D7 794",
    transform: "translate(536.485 3664.048)",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_505",
    "data-name": "\\u30D1\\u30B9 505",
    d: "M990.856,3915.135V3884.93c0-.6.057-1.273.057-2a7.6,7.6,0,0,0,1.858-4.586c0-1.245-.124-2.738.861-3.5.737-.575,1.791-.441,2.719-.613,3.112-.584,4.251-4.585,3.705-7.659s-2.1-6.118-1.819-9.277c.306-3.408,2.661-6.214,4.662-8.99s3.83-6.232,2.757-9.5c-.737-2.355-2.786-4.04-3.964-6.213-1.522-2.815-1.465-6.2-1.1-9.382s.958-6.4.5-9.574-2.47-6.348-5.562-7.161a6.948,6.948,0,0,1-2.7-.881,6.687,6.687,0,0,1-1.436-2.394c-1.379-2.719-4.462-4.117-7.449-4.786-6.184-1.3-11.613,1.34-17.664,1.082-4.624-.2-13.633-4.787-12.618,3.3a11.325,11.325,0,0,1-4.786,10.531c-2.968,1.991-7.372,3.188-7.774,6.7-.335,2.978,2.575,5.228,3.83,7.966,1.982,4.471-.785,9.573-3.83,13.4a8.543,8.543,0,0,0-1.943,3.15c-.642,2.479,1.148,4.882,2.93,6.7s3.83,3.83,3.83,6.405-2.068,4.72-3.629,6.845-2.537,5.409-.584,7.171c1.311,1.177,3.714,1.465,3.963,3.207.154,1.043-.641,1.915-1.283,2.805-4.174,5.543-2.068,14.657,4.107,17.817a20.167,20.167,0,0,0,7.075,1.79l-.556,19.147c-2.939.258-4.691.45-4.691.45s-4.356.757-11.412,1.714v-52.5l-2.872-10.838-2.872-6.28-2.872-5.744-2.278-3.428-3.428,2.872,5.744,5.132,5.744,10.272v31.383l-5.131-21.684v-2.873l-4.567-3.427-2.872-3.428,2.872,7.985,4.567,5.744.555,6.271h-3.427l-3.428-4.566,1.714,7.419h6.281l1.714,5.744V3899.2l-6.281-10.838-9.114-1.694,9.134,3.428,6.28,11.948v17.176c-4.9.622-10.665,1.273-16.936,1.838l.105-1.589c1.139-.574-.575-3.427-.575-3.427v-3.428c6.281,6.845,11.412,1.714,11.412,1.714l-7.41-6.29H906.7l-3.428-2.872V3902.3l-1.714.574-.574,1.714-2.279-.574-.574-1.714h-1.1l.574,2.278c.575,2.279-1.714,5.744-1.714,5.744-.574,2.873,3.992,2.279,3.992,2.279a3.944,3.944,0,0,0,2.279,2.556v6.941c-19.08.958-39.779.526-53.92-4.107-33.1-10.837-61.051-2.872-61.051-2.872s-11.364,2.537-27.764,4.385l-2.355-27.764a2.23,2.23,0,0,0,1.991.048c1.771-.958.958-3.59,1.369-5.543.651-3.169,4.557-4.337,6.6-6.855s2.078-6.376,4.279-8.808a40.144,40.144,0,0,1,3.418-2.757c4.126-3.638,3.532-11.24-1.092-14.208a11.737,11.737,0,0,1-2.2-1.493c-2.23-2.288-.555-6.1-.957-9.268a9.021,9.021,0,0,0-4.845-6.318c-4.71-2.518-10.723-3.476-15.892-4.433a3.964,3.964,0,0,1-2.068,4.873,7.654,7.654,0,0,1-2.671.44,8.383,8.383,0,0,0-3.685.738,2.872,2.872,0,0,0-1.571,3.13,16.99,16.99,0,0,0,.958,1.733c.881,1.992-.746,4.136-2.221,5.745s-2.987,3.886-1.915,5.744c.67,1.168,2.135,1.695,2.872,2.824,1.359,2.067-.325,4.71-1.809,6.7s-2.719,5.045-.852,6.7a8.4,8.4,0,0,0,2.384,1.11c5.974,2.48,6.146,11.8,11.853,14.849a17.114,17.114,0,0,1,2.173,1.139,5.343,5.343,0,0,1,.958.891c.1,6.558.325,23.571.144,31.373-5.993.574-12.522,1.033-19.3,1.225v-13.68c1.13-.584,2.115-1.58,3.3-2.107,1.714-.757,3.676-.478,5.553-.612s3.992-.958,4.433-2.805a13.913,13.913,0,0,0,0-2.594,1.952,1.952,0,0,1,1.34-2,14.383,14.383,0,0,0-1.2-3.035c-1.091-2.757-.422-6-1.695-8.683a13,13,0,0,0-3.685-4.1l-2.174-1.819c-2.7-2.259-5.467-4.547-8.741-5.859-.871-.344-1.771-.612-2.661-.881-.613.335-.632,1.245-.431,1.915a3.354,3.354,0,0,1,.278,2.164,2.306,2.306,0,0,1-1.6,1.139,23.206,23.206,0,0,0-2.94.833,3.016,3.016,0,0,0-1.915,2.211,5.151,5.151,0,0,0-3.476.594c-.957.718-1.1,2.527,0,2.958a5.677,5.677,0,0,0-1.282,6.788c.785,1.455,2.221,2.575,2.594,4.184.336,1.427-.258,3,.269,4.375a19.251,19.251,0,0,1,1.014,2.059,14.617,14.617,0,0,0,.23,1.838,2.939,2.939,0,0,0,2.489,1.7,29.043,29.043,0,0,1,3.169.268c1.465.326,2.776,1.321,4.184,1.724l-.958,13.489a207.92,207.92,0,0,1-23.6-.957l-.671-31.287.1-.067a1.706,1.706,0,0,0,.441-.785c.66-2.269-1.063-5.169.6-6.845.814-.813,2.116-.9,3-1.637,1.915-1.561.766-4.787,2.116-6.826.689-1.034,1.915-1.57,2.872-2.374a7.928,7.928,0,0,0,2.547-5.582,18.9,18.9,0,0,0-.891-6.213c-.45-1.608-.958-3.313-.469-4.912.545-1.78,2.24-3.025,2.872-4.786.958-2.872-1.226-5.792-3.284-8.042-3.188-3.485-5.611-4.787-10.2-5.352-1.513-.2-2.872-.881-4.385-1.053-2.872-.316-2.48.527-3.389,2.566-.756,1.694-3.7.776-4.873,2.212a2.87,2.87,0,0,0-.067,2.872,10.672,10.672,0,0,1,1.092,2.776c.172,1.436-.661,2.8-.958,4.222a5.456,5.456,0,0,0,2.805,5.639,8.368,8.368,0,0,0-1.168,10.225,15.763,15.763,0,0,1,2.059,3.2c.957,2.872-1.426,6.462.278,9.018.316.479.766.871,1.091,1.34,1.283,1.915.45,4.452.957,6.7a5.62,5.62,0,0,0,4.2,4.011l1.034,30.8q-3.829-.441-7.659-1.073c-4.385-.728-8.674-1.331-12.839-1.819v-14.284c1.13-.584,2.116-1.58,3.3-2.106,1.714-.757,3.676-.479,5.553-.613s3.992-.957,4.432-2.805a13.83,13.83,0,0,0,0-2.594,1.951,1.951,0,0,1,1.34-2,14.344,14.344,0,0,0-1.2-3.035c-1.092-2.757-.421-6-1.694-8.684a13.005,13.005,0,0,0-3.619-4.136l-2.173-1.819c-2.7-2.26-5.467-4.547-8.741-5.859-.871-.345-1.771-.613-2.661-.881-.612.335-.632,1.245-.431,1.914a3.353,3.353,0,0,1,.278,2.164,2.307,2.307,0,0,1-1.6,1.139,23.323,23.323,0,0,0-2.939.833,3.018,3.018,0,0,0-1.915,2.212,5.151,5.151,0,0,0-3.475.593c-.958.718-1.1,2.528,0,2.959a5.678,5.678,0,0,0-1.283,6.788c.785,1.455,2.221,2.575,2.595,4.183.335,1.427-.258,3,.268,4.375a19.111,19.111,0,0,1,1.015,2.058,14.634,14.634,0,0,0,.23,1.839,2.939,2.939,0,0,0,2.489,1.7,29.09,29.09,0,0,1,3.169.268c1.465.325,2.776,1.321,4.184,1.723l-.957,13.566c-5.448-.564-10.656-.957-15.548-1.177v-26.471l-1.139-15.4,9.7-14.839-9.7,12.551.345-9.008.957.258c.709.192,1.618.326,2.049-.277s.048-1.743.708-2.164a1.435,1.435,0,0,1,.871-.134l3.14.172c1.206-1.618-1.694-3.542-1.494-5.553.134-1.331,1.57-2.1,2.872-2.47s2.757-.66,3.5-1.771c1.12-1.647-.048-3.992.679-5.84a12.527,12.527,0,0,1,1.58-2.269,2.392,2.392,0,0,0,.326-2.594,3.414,3.414,0,0,0-1.532-1.006,10.971,10.971,0,0,1-5.745-6.49,2.1,2.1,0,0,1-.057-1.541c.345-.7,1.254-.862,1.915-1.207,2.23-1.13,2.278-4.375,1.264-6.7a7.108,7.108,0,0,0-2.623-3.284,3.907,3.907,0,0,0-4.05-.144,11.32,11.32,0,0,0-1.666,1.58,7.038,7.038,0,0,1-5.208,1.915c-1.436-.077-3.169-1.254-2.623-2.595s2.594-.958,3.83-1.79a3.5,3.5,0,0,0,1.3-2.815c.182-3.16-1.474-6.319-.747-9.392a11.787,11.787,0,0,0,.44-1.915c.105-1.541-.957-2.872-2.106-3.944a14.288,14.288,0,0,1-3.246-3.275c-.957-1.761-1.033-3.935-3.217-4.672a9.217,9.217,0,0,0-5.744.545c-1.646.814-1.914,1.656-1.474,3.351.5,1.857,1.254,3.762-1.915,3.169-1.167-.21-2.632-.479-3.3.5-.526.776-.153,1.81-.057,2.748s-.6,2.164-1.474,1.819c-.048,1.234,2.039,1.244,2.681,2.307a1.7,1.7,0,0,1-.795,2.192,4.937,4.937,0,0,1-2.528.431,14.452,14.452,0,0,1-1.5-2.116c-.555-.67-1.714-1.034-2.23-.335a1.911,1.911,0,0,0-.258,1.043l-.23,4.566a3.5,3.5,0,0,0,.057,1.092,5.832,5.832,0,0,0,.489,1.034,4.413,4.413,0,0,1-.709,4.854l1.283.565c-.5,1.207-2.422.373-3.59.958-.958.44-1.139,1.627-1.2,2.652a18.6,18.6,0,0,0,.431,5.313c.431,1.781,1.034,4.059-.469,5.122a6.2,6.2,0,0,1-1.973.67,1.981,1.981,0,0,0-1.532,1.273c-.153.68.718,1.446,1.245.957l-.44,2.661a3.212,3.212,0,0,0,1.752.153c.364,1.724-1.465,3.007-2.939,3.964s-2.977,2.872-1.915,4.26c.383.489,1.024.766,1.282,1.331a4.028,4.028,0,0,1,.144,1.513c.124,2.432,3.016,4.021,3.188,6.453,2.288.258,3.677-2.308,5.141-4.088a.889.889,0,0,1,.6-.4.956.956,0,0,1,.565.278l1.839,1.493a9.135,9.135,0,0,0,.2-3.734,16.978,16.978,0,0,1,2.652.115l-.392,5.323v28.53l1.062,30.282A196.089,196.089,0,0,0,624,3916.811v12.551h384.577v-11.909C1004.049,3916.064,997.711,3915.394,990.856,3915.135Zm-328.379-39.616-1.972-14.1,1.532.421Zm-18.832,9.7V3851.47a17,17,0,0,1,3.074.8,5.787,5.787,0,0,1,1.646.852,3.527,3.527,0,0,1,.345.306l.067,2.106-1.139,27.39v32.464h-2.4Zm7.994,30.176v-60.41a3.312,3.312,0,0,0,2.48-1.044,6.063,6.063,0,0,0,2.049,3.37,2.873,2.873,0,0,0-.747,2.729l3.456.958,2.45,16.275,1.149,12.513-1.58,25.772C657.69,3915.441,654.55,3915.394,651.639,3915.394Zm264.188,3.485-.192,2.316.957-.086-1.551.134-.641-3.532Zm-3.992-2.872,1.139,2.278v3.112c-2.585.211-5.237.392-7.927.555l1.082-5.945Zm-8.2-.546a4.152,4.152,0,0,0,.775,0l-.546,6.587-.958.057Zm74.378-33.508a28.641,28.641,0,0,1,2.566,1.914v31.115c-1.761,0-3.514.067-5.237.125l-1.216-33.335.057-.048a3.58,3.58,0,0,1,3.83.258Zm-5.687,4.844c.411-1.119.45-2.469.833-3.571v32l-3.427.153V3889.42a4.632,4.632,0,0,0,2.594-2.594Zm-11.719,3.705c.469-1.4,1.417-2.585,2.776-2.355a6.235,6.235,0,0,1,2.03,1.12,4.192,4.192,0,0,0,1.474.546v25.772c-2.25.134-4.365.278-6.281.422Zm22.824,24.547V3885.37a7.776,7.776,0,0,0,2.413.2c-.077.728-.124,1.139-.124,1.139l1.551,28.4c-1.273-.086-2.556-.1-3.839-.086Z",
    transform: "translate(-624 -3792.362)",
    fill: "#224ea8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_506",
    "data-name": "\\u30D1\\u30B9 506",
    d: "M800.381,3927.364Z",
    transform: "translate(-694.888 -3846.62)",
    fill: "#224ea8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_507",
    "data-name": "\\u30D1\\u30B9 507",
    d: "M800.029,3927.348l.182.058h0Z",
    transform: "translate(-694.746 -3846.613)",
    fill: "#224ea8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_508",
    "data-name": "\\u30D1\\u30B9 508",
    d: "M805.264,3928.191l-4.643-.747A10.911,10.911,0,0,0,805.264,3928.191Z",
    transform: "translate(-694.984 -3846.652)",
    fill: "#224ea8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_509",
    "data-name": "\\u30D1\\u30B9 509",
    d: "M716.072,3919.633l.182.058h0Z",
    transform: "translate(-661.004 -3843.512)",
    fill: "#224ea8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_510",
    "data-name": "\\u30D1\\u30B9 510",
    d: "M721.308,3920.556l-4.643-.747A10.922,10.922,0,0,0,721.308,3920.556Z",
    transform: "translate(-661.242 -3843.583)",
    fill: "#224ea8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_511",
    "data-name": "\\u30D1\\u30B9 511",
    d: "M716.472,3919.729Z",
    transform: "translate(-661.165 -3843.551)",
    fill: "#224ea8"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_512",
    "data-name": "\\u30D1\\u30B9 512",
    d: "M666.622,3561.616a36.973,36.973,0,0,0,5.052.419c1.743,0,3.19-.2,4.787-.311,3.266-.221,7.038-.072,10.556-.156,2.266-.054,4.511-.2,6.767-.144,1.544.042,2.911.179,4.389.263a24.861,24.861,0,0,0,4.431-.078l1.684,1.3a1.643,1.643,0,0,0,.85.347,8.542,8.542,0,0,0,2.113.066c.286.467-2.057.927-4.974.987-1.963.042-3.961-.084-5.927-.03-2.242.06-3.978.335-6.038.49a56.229,56.229,0,0,1-6.055.1c-2.3-.09-4.288-.311-6.467-.46-5.264-.353-11.5-.239-16.549-.664a6.454,6.454,0,0,1-1.045-.144c-.394-.114-.035-.257.048-.383.157-.245-.7-.472-1.248-.706s-.722-.532.467-.688A21.4,21.4,0,0,1,666.622,3561.616Z",
    transform: "translate(-101.409 -35.49)",
    fill: "#224ea8",
    opacity: 0.2,
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_513",
    "data-name": "\\u30D1\\u30B9 513",
    d: "M1044.232,3763.7a32.418,32.418,0,0,0,5.629.6c1.942,0,3.555-.291,5.333-.444,3.64-.316,7.844-.1,11.763-.222,2.525-.077,5.027-.291,7.54-.205,1.721.06,3.244.256,4.891.376a21.7,21.7,0,0,0,4.938-.111l1.876,1.854a1.641,1.641,0,0,0,.948.5,7.444,7.444,0,0,0,2.354.094c.319.667-2.292,1.324-5.544,1.41-2.187.06-4.413-.12-6.6-.043-2.5.085-4.432.478-6.728.7a48.991,48.991,0,0,1-6.748.137c-2.564-.129-4.778-.445-7.207-.659-5.866-.5-12.82-.341-18.441-.948a5.742,5.742,0,0,1-1.165-.205c-.439-.163-.039-.367.054-.547.175-.35-.777-.675-1.391-1.008s-.8-.761.52-.982C1039.186,3763.486,1040.418,3763.1,1044.232,3763.7Z",
    transform: "translate(-252.802 -116.672)",
    fill: "#224ea8",
    opacity: 0.2,
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_514",
    "data-name": "\\u30D1\\u30B9 514",
    d: "M1190.832,3625.876a12.92,12.92,0,0,0,3.029.449,22.765,22.765,0,0,0,2.87-.329c1.956-.239,4.22-.078,6.325-.167,1.358-.054,2.7-.215,4.053-.15.927.048,1.758.191,2.637.281a8.429,8.429,0,0,0,2.638-.084l1.011,1.382a.869.869,0,0,0,.51.371,2.9,2.9,0,0,0,1.266.072c.172.5-1.231.993-2.98,1.053-1.178.042-2.374-.09-3.543-.03-1.345.065-2.382.359-3.618.526a18.8,18.8,0,0,1-3.626.1c-1.38-.1-2.567-.335-3.878-.49-3.156-.377-6.9-.251-9.916-.712a2.36,2.36,0,0,1-.633-.15c-.233-.125,0-.275.026-.413.093-.263-.417-.509-.747-.754s-.439-.568.281-.736A7.288,7.288,0,0,1,1190.832,3625.876Z",
    transform: "translate(-313.384 -61.31)",
    fill: "#224ea8",
    opacity: 0.2,
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\u30B0\\u30EB\\u30FC\\u30D7_795",
    "data-name": "\\u30B0\\u30EB\\u30FC\\u30D7 795",
    transform: "translate(553.598 3582.199)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "\\u6955\\u5186\\u5F62_114",
    "data-name": "\\u6955\\u5186\\u5F62 114",
    cx: 177.635,
    cy: 29.307,
    rx: 177.635,
    ry: 29.307,
    transform: "translate(0 335.562)",
    fill: "#224ea8",
    opacity: 0.1,
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_515",
    "data-name": "\\u30D1\\u30B9 515",
    d: "M856.755,3790.173c1.25,0,2.536.066,4.121.066,1.417,0,2.6-.03,3.906-.048,2.662-.036,5.742,0,8.607,0,1.848,0,3.678-.03,5.514,0,1.262,0,2.392,0,3.589.042s2.7,0,3.589,0l1.376.2a5.58,5.58,0,0,0,.694.054h1.722a26.031,26.031,0,0,1-4.055.149H881c-1.83,0-3.242.054-4.922.078h-4.934c-1.878,0-3.493-.048-5.275-.072-4.294-.054-9.384-.036-13.493-.1h-.861c-.317,0,0-.042.036-.06a4.581,4.581,0,0,0-1.017-.107c-.455-.036-.6-.084.383-.108C853.07,3790.155,853.961,3790.113,856.755,3790.173Z",
    transform: "translate(-732.015 -3709.622)",
    fill: "#224ea8",
    opacity: 0.2,
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_516",
    "data-name": "\\u30D1\\u30B9 516",
    d: "M947.2,3708.533c.652,0,1.328.065,2.159.065s1.364-.03,2.046-.048c1.394-.036,2.99,0,4.51,0,.969,0,1.926-.03,2.889,0,.658,0,1.244,0,1.878.042s1.417,0,1.89,0l.718.2a1.563,1.563,0,0,0,.365.054h.9a7.287,7.287,0,0,1-2.129.15H959.9c-.957,0-1.7.054-2.578.078s-1.728,0-2.59,0c-.981,0-1.83-.048-2.763-.072-2.249-.054-4.916-.036-7.076-.1h-.449c-.167,0,0-.042,0-.06a3.1,3.1,0,0,0-.532-.108c-.233-.036-.311-.084.2-.108A25.579,25.579,0,0,1,947.2,3708.533Z",
    transform: "translate(-769.614 -3676.816)",
    fill: "#224ea8",
    opacity: 0.2,
    style: {
      isolation: "isolate"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_517",
    "data-name": "\\u30D1\\u30B9 517",
    d: "M964.483,3782.739c-2.955-8.732-8.331-25.5-8.092-31.31.167-4.02-2.949-9.654-6.089-14.265l1.794-4.9-.209-.377.209-.6s-2.392-4.145-2.7-6.764a2.065,2.065,0,0,1,.048-.263c.1-.335.066-.509-.066-.6a2.091,2.091,0,0,1,.066-.389c.664-2.237-4.653,2.554-4.653,2.554l.257.73-.257.227.6,1.627c-1.16-.646-2.506-1.382-3.983-2.159a6.362,6.362,0,0,0,.76-3.589,10.4,10.4,0,0,0-1.346-5.383c-1.447-2.686-3.625-4.976-4.934-7.728a4,4,0,0,1-.257-.664,1.074,1.074,0,0,1,.1-.191c.245-.395.73-.6,1.089-.885a2.825,2.825,0,0,0,.76-2.536,6.389,6.389,0,0,0-.179-2.052,37.775,37.775,0,0,0-4.605-11.31,20.428,20.428,0,0,1-2.691-5.192c-.6-2.177-.2-4.5-.706-6.687-.55-2.392-2.081-4.408-3.589-6.364l-11.771-15.389a8.383,8.383,0,0,0-1.884-1.974c-2.213-1.489-4.91-.6-7.141.341-2.6,1.077-3.768-.107-6.459,0a3.7,3.7,0,0,0-3.331,1.986,16.5,16.5,0,0,0-.407,2.667c-.437,1.938-2.3,3.128-3.774,4.576a19.424,19.424,0,0,0-6.89,14.773,19.1,19.1,0,0,0,.514,4.39c-2.237,3.433-4.456,6.836-4.258,10.766a9.579,9.579,0,0,0,0,1.112c.048.754.191,1.513.245,2.261a4.231,4.231,0,0,1-.12.76c-.676,2.5-3.618,3.588-6.035,4.737A23.666,23.666,0,0,0,861.6,3720.7c-2.04.963-3.935,1.866-5.544,2.656l.4-.353-4.4-2.237s-1.992,6.71-4.653,8.307a1.369,1.369,0,0,0-.52,1.621c-.413,1.37,1.388,3.929,2.99,5.844-1.794,3.475-3.4,7.177-3.786,10.1-1,7.667-4.988,19.486-4.988,19.486s-7.644,12.135,0,25.234,20.276,5.431,20.276,5.431-1.047,6.023-2.153,11.962c-1.2,5.6-2.093,10.341-2.093,10.341h0c-1.2,6.077-2.075,16.7-2.075,16.7s-3.654,44.72-5.652,47.6c-.7,1.011,4.258,4.025,13.643,6.854q.245.807.508,1.7c2.123,7.339,4.785,18.917,3.965,28.5,0,0,.664,5.114-1.328,15.335s-2.327,39.606,2.327,53.344v12.883c-.807.455-1.6,1.962-.831,6.579l1,4.474s-3.325-6.071-7.644,4.785,11.3,19.139,18.613,19.8a18.271,18.271,0,0,0,4.522-.1,3.8,3.8,0,0,0,3-5.048l-.6-1.567s2.99-9.57-.335-13.416c0,0,4.324-13.1,1.992-14.7,0,0-.544-.072-1.585.82-.042-.215-.09-.49-.143-.832-.461-2.745-1.31-9.157.233-12.124,1.992-3.833,3.654-25.234,3.654-25.234l.664-23.96,3.654-13.427s2.327-8.625,1.328-15.652c-.6-4.294.395-10.766,1.268-15.1.114-.562.221-1.088.329-1.573,3.2.149,6.525.215,9.976.179.108.5.215,1.029.329,1.6h.167c.861,4.354,1.824,10.664,1.226,14.893-1,7.028,1.328,15.652,1.328,15.652l3.654,13.415.664,23.96s1.663,21.4,3.654,25.234c1.567,2.99.67,9.57.215,12.255l-.048.275c-.054.3-.1.526-.126.676-1.226-1.154-1.866-1.071-1.866-1.071-2.327,1.6,1.992,14.7,1.992,14.7-3.326,3.833-.335,13.415-.335,13.415l-.6,1.567a3.8,3.8,0,0,0,3.044,5.048,18.3,18.3,0,0,0,4.522.1c7.315-.64,22.937-8.972,18.613-19.8s-7.644-4.785-7.644-4.785l1-4.474c.663-3.995.167-5.669-.5-6.345v-13.158c4.654-13.756,4.324-43.123,2.327-53.344s-1.328-15.335-1.328-15.335c-.748-8.625,1.346-18.864,3.319-26.173.162-.6.329-1.2.484-1.752q5.383-1.028,10.987-2.393c5.6-1.364-3.989-22.68,0-30.024,3.2-5.891-7.919-39.289-12.452-52.3h0l-1.124-4.91c2.506.933,11.519,3.589,18.6-3.786,1.914-1.986,3.4-3.631,4.563-4.988A11.6,11.6,0,0,0,964.483,3782.739ZM938.5,3802.7l-.06-.167.132.06Z",
    transform: "translate(-727.002 -3655.512)",
    fill: "url(#linear-gradient)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_518",
    "data-name": "\\u30D1\\u30B9 518",
    d: "M914.414,4052.017c-.837,4.348-1.794,10.766-1.2,15.048.957,7-1.274,15.6-1.274,15.6l-3.5,13.373-.634,23.882s-1.591,21.334-3.5,25.156c-1.483,2.96-.67,9.354-.227,12.087.126.8.227,1.286.227,1.286-2.548,19.1-17.512,1.274-17.512,1.274v-16.245c-4.456-13.69-4.139-42.985-2.231-53.177s1.274-15.281,1.274-15.281c.8-9.57-1.794-21.1-3.8-28.41-1.2-4.39-2.249-7.255-2.249-7.255l35.665,7.961S914.946,4049.254,914.414,4052.017Z",
    transform: "translate(-743.914 -3809.782)",
    fill: "#636e7e"
  })), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_519",
    "data-name": "\\u30D1\\u30B9 519",
    d: "M908.976,4236.283c-2.548,19.1-17.512,1.274-17.512,1.274V4233.2a1.368,1.368,0,0,1,1.112-.1c-.748,2.452.287,4.294,2,5.664a8.785,8.785,0,0,0,12.323-1.587c.081-.105.16-.212.237-.321a12.394,12.394,0,0,1,1.585-1.86C908.875,4235.8,908.976,4236.283,908.976,4236.283Z",
    transform: "translate(-748.608 -3887.617)",
    opacity: 0.1,
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_520",
    "data-name": "\\u30D1\\u30B9 520",
    d: "M989.366,4233.307v4.247s-14.953,17.829-17.512-1.274c0,0,.084-.431.209-1.154a13.186,13.186,0,0,1,1.441,1.729A8.786,8.786,0,0,0,985.744,4239c.109-.077.216-.155.321-.237a5,5,0,0,0,2-5.664A1.361,1.361,0,0,1,989.366,4233.307Z",
    transform: "translate(-780.917 -3887.613)",
    opacity: 0.1,
    style: {
      isolation: "isolate"
    }
  }), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_521",
    "data-name": "\\u30D1\\u30B9 521",
    d: "M887.287,4234.7s-3.182-1.274-1.908,6.687l.957,4.455s-3.182-6.052-7.321,4.785,10.826,19.1,17.829,19.737a16.873,16.873,0,0,0,4.33-.1,3.8,3.8,0,0,0,2.913-5.018l-.556-1.561s2.865-9.57-.317-13.374c0,0,4.139-13.057,1.908-14.647,0,0-1.118-.162-3.242,2.8a8.786,8.786,0,0,1-12.239,2.145q-.163-.115-.321-.237C887.581,4239,886.54,4237.141,887.287,4234.7Z",
    transform: "translate(-743.319 -3888.26)",
    fill: "#63667e"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_522",
    "data-name": "\\u30D1\\u30B9 522",
    d: "M985.966,4048.933c-1.89,7.285-3.894,17.495-3.176,26.089,0,0-.634,5.1,1.274,15.281s2.231,39.475-2.231,53.177v16.238s-14.953,17.83-17.512-1.274c0,0,.066-.323.161-.879l.048-.275c.431-2.662,1.3-9.21-.209-12.219-1.908-3.822-3.5-25.156-3.5-25.156l-.634-23.882-3.5-13.373s-2.231-8.595-1.274-15.6c.6-4.187-.353-10.5-1.2-14.845-.55-2.877-1.053-4.9-1.053-4.9l35.665-7.961S987.455,4043.263,985.966,4048.933Z",
    transform: "translate(-773.402 -3809.778)",
    fill: "#636e7e"
  })), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_523",
    "data-name": "\\u30D1\\u30B9 523",
    d: "M989.366,4233.847v3.93s-14.953,17.83-17.512-1.274c0,0,.066-.323.161-.879a13.083,13.083,0,0,1,1.489,1.794,8.786,8.786,0,0,0,12.239,2.145c.109-.076.216-.155.321-.236a5,5,0,0,0,2-5.664A1.357,1.357,0,0,1,989.366,4233.847Z",
    transform: "translate(-780.917 -3887.837)",
    opacity: 0.1,
    style: {
      isolation: "isolate"
    }
  }), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_524",
    "data-name": "\\u30D1\\u30B9 524",
    d: "M986.306,4234.7s3.182-1.274,1.908,6.687l-.957,4.455s3.182-6.052,7.321,4.785-10.826,19.1-17.829,19.737a16.872,16.872,0,0,1-4.33-.1,3.8,3.8,0,0,1-2.913-5.03l.556-1.561s-2.865-9.57.317-13.374c0,0-4.139-13.056-1.908-14.647,0,0,1.118-.162,3.242,2.805a8.786,8.786,0,0,0,12.239,2.145c.109-.077.216-.155.321-.237C986.013,4239,987.071,4237.141,986.306,4234.7Z",
    transform: "translate(-779.292 -3888.26)",
    fill: "#63667e"
  })), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_525",
    "data-name": "\\u30D1\\u30B9 525",
    d: "M879.754,4039.371l35.665,7.961s-.479,1.926-1.011,4.695a137,137,0,0,1-32.4-5.383C880.783,4042.236,879.754,4039.371,879.754,4039.371Z",
    transform: "translate(-743.902 -3809.786)",
    opacity: 0.1,
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_526",
    "data-name": "\\u30D1\\u30B9 526",
    d: "M988.613,4039.371s-1.4,3.9-2.871,9.57a176.632,176.632,0,0,1-31.735,3.265c-.55-2.876-1.053-4.9-1.053-4.9Z",
    transform: "translate(-773.321 -3809.786)",
    opacity: 0.1,
    style: {
      isolation: "isolate"
    }
  }), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_527",
    "data-name": "\\u30D1\\u30B9 527",
    d: "M859.981,3774.781s-8.918,13.056-9.869,20.694-4.785,19.42-4.785,19.42-7.321,12.1,0,25.156,19.438,5.419,19.438,5.419-2.548,15.281-3.822,21.017-2.231,17.829-2.231,17.829-3.5,44.576-5.413,47.441,40.12,21.968,99.027,6.687c0,0-3.822-22.608,0-29.9s-13.69-57.316-13.69-57.316,10.509,5.1,18.469-3.5c1.83-1.98,3.26-3.619,4.372-4.977a11.926,11.926,0,0,0,2.105-11.256c-2.829-8.7-7.985-25.425-7.775-31.209.317-7.96-11.783-22.291-11.783-22.291Z",
    transform: "translate(-728.758 -3703.447)",
    fill: "#e29d9d"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_528",
    "data-name": "\\u30D1\\u30B9 528",
    d: "M911.4,3754.313a41.269,41.269,0,0,0-29.9,2.225c-8.445,4.025-17.506,8.457-18.667,9.45a2.075,2.075,0,0,0,0,3.5l25.156,2.865h49.989l19.1-1.591s-17.512-11.143-26.43-11.783C926.423,3758.679,918.529,3756.507,911.4,3754.313Z",
    transform: "translate(-736.701 -3694.491)",
    fill: "#f1c0c0"
  })), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_529",
    "data-name": "\\u30D1\\u30B9 529",
    d: "M1000.965,3868.1l-2.231-9.869a96.183,96.183,0,0,1,3.5-18.469c2.865-9.57-.634-22.925-.634-22.925",
    transform: "translate(-791.72 -3720.351)",
    opacity: 0.1,
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_530",
    "data-name": "\\u30D1\\u30B9 530",
    d: "M879.444,3816.831s-1.908,7.321,0,11.466,0,13.057,0,13.057-.634,14.647.957,19.42",
    transform: "translate(-743.437 -3720.347)",
    opacity: 0.1,
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_531",
    "data-name": "\\u30D1\\u30B9 531",
    d: "M893.1,3836.531s-4.139,10.825-6.053,13.373-4.139,13.374-6.37,15.6-6.932,28.254-6.932,28.254,12.979,9.958,19.348,18.236,40.437-2.231,40.437-2.231,2.548-12.1,6.687-14.007c1.489-.688,1.657-1.537,1.268-2.351a37.035,37.035,0,0,1-3.63-13.2c-.963-12.117-3.953-31.525-13.236-40.174Z",
    transform: "translate(-741.487 -3728.264)",
    opacity: 0.1,
    style: {
      isolation: "isolate"
    }
  }), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_532",
    "data-name": "\\u30D1\\u30B9 532",
    d: "M892.568,3834.411s-4.139,10.826-6.053,13.374-4.139,13.374-6.37,15.6-6.932,28.254-6.932,28.254,12.979,9.958,19.349,18.236,40.443-2.249,40.443-2.249,2.548-12.1,6.687-14.008c1.489-.687,1.657-1.537,1.268-2.35a37.032,37.032,0,0,1-3.63-13.2c-.963-12.118-3.953-31.526-13.236-40.174Z",
    transform: "translate(-741.273 -3727.412)",
    fill: "#224ea8"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "\\u6955\\u5186\\u5F62_115",
    "data-name": "\\u6955\\u5186\\u5F62 115",
    cx: 5.73,
    cy: 5.73,
    r: 5.73,
    transform: "translate(158.771 165.427)",
    opacity: 0.1,
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_533",
    "data-name": "\\u30D1\\u30B9 533",
    d: "M916.25,3839.2s-7.961,9.57-3.182,17.2l2.231.957s1.274-16.556,2.865-17.512Z",
    transform: "translate(-756.677 -3729.337)",
    opacity: 0.1,
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_534",
    "data-name": "\\u30D1\\u30B9 534",
    d: "M930.311,3839.2s-2.231,17.512-.634,19.1c0,0,6.053,1.274,6.687-.957,0,0-3.5-14.952-2.548-16.878Z",
    transform: "translate(-763.735 -3729.337)",
    opacity: 0.1,
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_535",
    "data-name": "\\u30D1\\u30B9 535",
    d: "M943.9,3841.591s2.548,13.056,4.785,10.825-1.591-10.825-1.591-10.825Z",
    transform: "translate(-769.684 -3730.298)",
    opacity: 0.1,
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_536",
    "data-name": "\\u30D1\\u30B9 536",
    d: "M890.1,3812.746s19.1,3.822,29.307.634,36.3-29.516,36.3-29.516l1.908-5.514s-3.212-5.73-2.566-7.949-4.456,2.548-4.456,2.548l.879,2.608s-82.394,4.713-90.672-.7l5.168-4.785-4.187-2.231s-1.908,6.687-4.456,8.278,4.456,8.918,4.456,8.918S880.547,3811.5,890.1,3812.746Z",
    transform: "translate(-734.665 -3700.658)",
    opacity: 0.1,
    style: {
      isolation: "isolate"
    }
  }), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_537",
    "data-name": "\\u30D1\\u30B9 537",
    d: "M890.111,3811.148s19.1,3.822,29.307.634,36.3-29.516,36.3-29.516l1.908-5.515s-3.182-5.729-2.548-7.96-4.456,2.548-4.456,2.548l.879,2.608s-82.394,4.713-90.672-.7l5.168-4.785-4.187-2.231s-1.908,6.687-4.456,8.278,4.456,8.917,4.456,8.917S880.559,3809.875,890.111,3811.148Z",
    transform: "translate(-734.677 -3700.01)",
    fill: "#e29d9d"
  })), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_538",
    "data-name": "\\u30D1\\u30B9 538",
    d: "M867.774,3785.422s3.5-1.274,12.417,1.274,19.737,0,19.737,0,48.081-.957,51.9-.317S962,3783.831,962,3783.831",
    transform: "translate(-739.087 -3707.084)",
    opacity: 0.1,
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_539",
    "data-name": "\\u30D1\\u30B9 539",
    d: "M980.1,3847.181s5.413,36.933,14.354,47.764C994.4,3894.945,982.969,3856.416,980.1,3847.181Z",
    transform: "translate(-784.233 -3732.544)",
    opacity: 0.1,
    style: {
      isolation: "isolate"
    }
  }), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "\\u6955\\u5186\\u5F62_116",
    "data-name": "\\u6955\\u5186\\u5F62 116",
    cx: 19.743,
    cy: 19.743,
    r: 19.743,
    transform: "translate(157.814 6.537)",
    fill: "#765656"
  })), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_540",
    "data-name": "\\u30D1\\u30B9 540",
    d: "M915.485,3660.289a3.543,3.543,0,0,0-3.194,1.98,17.226,17.226,0,0,0-.389,2.656c-.6,2.625-3.66,3.882-4.916,6.256s-.479,5.072-.664,7.656c-.526,7.488-8.7,13.116-8.212,20.611a12.654,12.654,0,0,1,.114,3.965c-.646,2.494-3.469,3.588-5.778,4.725a23.387,23.387,0,0,0-12.626,17.6,9.134,9.134,0,0,0,.6,5.383,4.319,4.319,0,0,0,4.492,2.452c2.667-.6,3.589-4.109,5.981-5.455,1.083,1.627.658,3.81,1.2,5.688.6,1.991,2.7,3.618,4.725,3.116s2.955-3.589,1.25-4.785c2.225.269,3.69,2.536,4.157,4.731s.257,4.492.777,6.675a10.532,10.532,0,0,0,10.766,7.775,6.041,6.041,0,0,1,2.093,0,5.773,5.773,0,0,1,1.794,1.052,12.193,12.193,0,0,0,8.654,2.213,2.883,2.883,0,0,1,2.452-2.189,8.481,8.481,0,0,1,3.469.365l5.323,1.322c1.549.383,3.547.6,4.42-.724.646-.993.281-2.345.736-3.439.742-1.795,3.164-2.046,5.1-1.872s4.247.329,5.449-1.2.395-3.983-.712-5.706-2.494-3.588-2.105-5.6c.544-2.835,4.1-3.869,5.79-6.2,1.794-2.44,1.2-5.9-.2-8.583s-3.469-4.964-4.731-7.7a1.973,1.973,0,0,1-.156-1.794,4.207,4.207,0,0,1,1.041-.879c.963-.849.831-2.392.556-3.618a38.535,38.535,0,0,0-4.456-11.31,20.711,20.711,0,0,1-2.578-5.174c-.55-2.171-.191-4.479-.676-6.669-.526-2.392-2-4.4-3.427-6.346l-11.274-15.341a8.255,8.255,0,0,0-1.794-1.968c-2.123-1.483-4.7-.6-6.836.335C919.187,3661.354,918.069,3660.158,915.485,3660.289Z",
    transform: "translate(-743.873 -3656.977)",
    opacity: 0.1,
    style: {
      isolation: "isolate"
    }
  }), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_541",
    "data-name": "\\u30D1\\u30B9 541",
    d: "M915.485,3658.7a3.544,3.544,0,0,0-3.194,1.98,17.232,17.232,0,0,0-.389,2.655c-.6,2.626-3.66,3.882-4.916,6.256s-.479,5.072-.664,7.656c-.526,7.488-8.7,13.116-8.212,20.61a12.654,12.654,0,0,1,.114,3.965c-.646,2.494-3.469,3.588-5.778,4.725a23.386,23.386,0,0,0-12.626,17.572,9.134,9.134,0,0,0,.6,5.383,4.32,4.32,0,0,0,4.492,2.452c2.667-.6,3.589-4.109,5.981-5.455,1.083,1.626.658,3.81,1.2,5.688.6,1.991,2.7,3.618,4.725,3.116s2.955-3.588,1.25-4.785c2.225.269,3.69,2.536,4.157,4.731s.257,4.492.777,6.675a10.532,10.532,0,0,0,10.766,7.775,6.029,6.029,0,0,1,2.093,0,5.765,5.765,0,0,1,1.794,1.053,12.2,12.2,0,0,0,8.654,2.213,2.884,2.884,0,0,1,2.452-2.189,8.469,8.469,0,0,1,3.469.365l5.323,1.322c1.549.383,3.547.6,4.42-.724.646-.993.281-2.344.736-3.439.742-1.794,3.164-2.045,5.1-1.872s4.247.329,5.449-1.2.395-3.983-.712-5.706-2.494-3.588-2.105-5.6c.544-2.835,4.1-3.87,5.79-6.2,1.794-2.44,1.2-5.9-.2-8.583s-3.469-4.964-4.731-7.7a1.972,1.972,0,0,1-.156-1.794,4.208,4.208,0,0,1,1.041-.879c.963-.849.831-2.393.556-3.619a38.541,38.541,0,0,0-4.408-11.274,20.719,20.719,0,0,1-2.578-5.174c-.55-2.171-.191-4.479-.676-6.668-.526-2.393-2-4.4-3.427-6.346l-11.274-15.341a8.246,8.246,0,0,0-1.794-1.968c-2.123-1.483-4.7-.6-6.836.335C919.187,3659.768,918.069,3658.584,915.485,3658.7Z",
    transform: "translate(-743.873 -3656.342)",
    fill: "#896363"
  })), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_542",
    "data-name": "\\u30D1\\u30B9 542",
    d: "M909.507,3737.251s-8.595,1.274-11.782,8.917-7.321,9.235-7.321,9.235",
    transform: "translate(-748.182 -3688.364)",
    opacity: 0.1,
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_543",
    "data-name": "\\u30D1\\u30B9 543",
    d: "M939.454,3674.961s4.785,10.826.317,18.152-1.908,20.694-1.908,20.694",
    transform: "translate(-766.963 -3663.329)",
    opacity: 0.1,
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_544",
    "data-name": "\\u30D1\\u30B9 544",
    d: "M932.763,3761.606s-4.785-1.908-2.865,6.053a22.934,22.934,0,0,1-.634,13.69",
    transform: "translate(-763.8 -3698.072)",
    opacity: 0.1,
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_545",
    "data-name": "\\u30D1\\u30B9 545",
    d: "M954.264,3759.61s-8.595-.323-5.574,10.826-.8,16.561-.8,16.561",
    transform: "translate(-771.288 -3697.349)",
    opacity: 0.1,
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_546",
    "data-name": "\\u30D1\\u30B9 546",
    d: "M958.544,3671.231s8.278,8.595,7.644,14.008-.317,24.522,0,25.473",
    transform: "translate(-775.568 -3661.83)",
    opacity: 0.1,
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_547",
    "data-name": "\\u30D1\\u30B9 547",
    d: "M976.644,3761.2s5.73,6.053,4.785,11.143,0,15.281,0,15.281",
    transform: "translate(-782.842 -3697.989)",
    opacity: 0.1,
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_548",
    "data-name": "\\u30D1\\u30B9 548",
    d: "M986.754,3715.951s4.139,7.644,3.182,14.354",
    transform: "translate(-786.905 -3679.802)",
    opacity: 0.1,
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_549",
    "data-name": "\\u30D1\\u30B9 549",
    d: "M892.9,3864.961s13.158,26.46,46.9,2.584",
    transform: "translate(-749.187 -3739.69)",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    opacity: 0.1,
    style: {
      isolation: "isolate"
    }
  }), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_550",
    "data-name": "\\u30D1\\u30B9 550",
    d: "M986.754,3929.431",
    transform: "translate(-786.905 -3765.601)",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_551",
    "data-name": "\\u30D1\\u30B9 551",
    d: "M986.224,3918.307l10.826-16.555,1.286,5.658-11.962,12.213",
    transform: "translate(-786.692 -3754.477)",
    fill: "#636e7e"
  })), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_552",
    "data-name": "\\u30D1\\u30B9 552",
    d: "M941.014,3980.541s10.168,24.522,0,45.521",
    transform: "translate(-768.522 -3786.142)",
    opacity: 0.1,
    style: {
      isolation: "isolate"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIllust404);
export default __webpack_public_path__ + "static/media/illust_404.ea098feb2307e20369dca3cfce882197.svg";
export { ForwardRef as ReactComponent };